import { Scissors } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SearchTruncatedNoticeProps {
  /**
   * До скольких символов сервер укоротил запрос; null — не укорачивал.
   *
   * Число приходит с сервера, а не берётся из константы: предел D1 на длину
   * шаблона `LIKE` меряется в БАЙТАХ, поэтому в символах он зависит от языка
   * (около 46 для латиницы, около 23 для кириллицы).
   */
  truncatedTo: number | null;
  className?: string;
}

/**
 * Пометка «запрос сокращён» рядом с результатами поиска.
 *
 * Обязательна везде, где ручка возвращает `searchTruncatedTo`. Обрезанный
 * запрос отдаёт НАДМНОЖЕСТВО правильного ответа — настоящие совпадения на
 * месте, но добавляются лишние; без пометки правка, снявшая громкий
 * пятисотый, превратилась бы в тихий неверный ответ.
 *
 * Рядом с выдачей, а не тостом: описывает то, что сейчас на экране, и должна
 * жить ровно столько же, сколько эта выдача.
 */
export function SearchTruncatedNotice({
  truncatedTo,
  className = '',
}: SearchTruncatedNoticeProps) {
  const { t } = useTranslation('common');

  if (truncatedTo === null) return null;

  return (
    <div
      data-testid="search-truncated-notice"
      role="status"
      className={`flex items-start gap-1.5 text-xs text-warning ${className}`}
    >
      <Scissors className="h-3.5 w-3.5 shrink-0 mt-px" aria-hidden="true" />
      <span>{t('common.searchTruncated', { chars: truncatedTo })}</span>
    </div>
  );
}
